import * as bootstrap from "../../../../modules/vendor/twbs/bootstrap/dist/js/bootstrap.bundle.min.js";
window.bootstrap = bootstrap;
// import "./components/_tooltipster";

import tippy from 'tippy.js';

//TOOLTIPS
document.querySelectorAll('.Tooltipster').forEach(el => {
    const parentEl = el.parentElement;
    const tooltipHTML = el.outerHTML;
    tippy(parentEl,{
        allowHTML: true,
        interactive: true,
        content: tooltipHTML,
        theme: 'light',
        appendTo: document.body,
    });

    el.style.display = 'none';
})
